import React from 'react';
import { Icon } from '@uhg-abyss/web/ui/Icon';

export const RightArrow = () => {
  const RightArrowIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fit=""
      preserveAspectRatio="xMidYMid meet"
      focusable="false"
      className="arrow-icon"
    >
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg>
  );
  return (
    <Icon
      title="right-arrow-icon"
      className="abyss-icon"
    >
      {RightArrowIcon}
    </Icon>
  );
};
